// This css file will need to be loaded in any route files that use it.
// import "mapbox-gl/dist/mapbox-gl.css";
import Layer from "ol/layer/Layer";
import Source from "ol/source/Source";
import { toLonLat } from "ol/proj";

const key =
  "pk.eyJ1IjoibmViYWluIiwiYSI6ImNqbG82eHR1cTFxYnozcG1xaWFyYTNiMm8ifQ.S4gGWUiMdWI-QjY9b0W-1w";

class MbGlLayerFactory {
  constructor() {
    // load mapboxgl separately because it's huge and not used on all maps
    this._mapboxgl = import("mapbox-gl");
  }

  async makeLayer({ map, style, cancel, ...mapboxMapOptions }) {
    const { default: mapboxgl } = await this._mapboxgl;
    if (cancel && cancel.current) {
      return; // skip making layer
    }
    this._mbMap = new mapboxgl.Map({
      style: style,
      attributionControl: false,
      boxZoom: false,
      center: toLonLat(map.getView().getCenter()),
      container: map.getTarget(),
      doubleClickZoom: false,
      dragPan: false,
      dragRotate: false,
      interactive: false,
      keyboard: false,
      pitchWithRotate: false,
      scrollZoom: false,
      touchZoomRotate: false,
      accessToken: key,
      ...mapboxMapOptions,
    });

    const instance = this;
    this._olLayer = new Layer({
      source: new Source({
        attributions:
          '© <a href="https://www.mapbox.com/about/maps/" target="_blank" rel="noopener noreferrer">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank" rel="noopener noreferrer">Improve this map</a></strong>',
      }),
      render: function (frameState) {
        const canvas = instance._mbMap.getCanvas();
        const viewState = frameState.viewState;

        const visible = instance._olLayer.getVisible();
        canvas.style.display = visible ? "block" : "none";
        canvas.style.position = "absolute";

        const opacity = instance._olLayer.getOpacity();
        canvas.style.opacity = opacity;

        // adjust view parameters in mapbox
        const rotation = viewState.rotation;
        instance._mbMap.jumpTo({
          center: toLonLat(viewState.center),
          zoom: viewState.zoom - 1,
          bearing: (-rotation * 180) / Math.PI,
          animate: false,
        });

        // cancel the scheduled update & trigger synchronous redraw
        // see https://github.com/mapbox/mapbox-gl-js/issues/7893#issue-408992184
        // NOTE: THIS MIGHT BREAK WHEN UPDATING MAPBOX
        if (instance._mbMap._frame) {
          instance._mbMap._frame.cancel();
          instance._mbMap._frame = null;
        }
        instance._mbMap._render();

        return canvas;
      },
    });
    return this._olLayer;
  }

  get olLayer() {
    return this._olLayer;
  }

  get mbMap() {
    return this._mbMap;
  }

  cleanup = () => {
    this._mbMap.remove();
  };

  handleResize = () => {
    this._mbMap.resize();
  };
}

export default MbGlLayerFactory;
